// ==================================
// App Principal
// ==================================

import { Routes, Route, Navigate } from 'react-router-dom';
import { MainLayout } from '@/componentes/layout';
import { PrivateRoute } from '@/componentes/auth';
import {
  Login,
  Dashboard,
  Veterinarias,
  VeterinariaDetalle,
  NuevaVeterinaria,
  EditarVeterinaria,
  Administradores,
  NuevoAdministrador,
  AdministradorDetalle,
  Pagos,
  Reportes,
  Configuracion,
} from '@/paginas';
import { useAuthStore } from '@/estado/authStore';

function App() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return (
    <Routes>
      {/* Ruta publica */}
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />

      {/* Rutas protegidas */}
      <Route element={<PrivateRoute />}>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/administradores" element={<Administradores />} />
          <Route path="/administradores/nuevo" element={<NuevoAdministrador />} />
          <Route path="/administradores/:id" element={<AdministradorDetalle />} />
          <Route path="/veterinarias" element={<Veterinarias />} />
          <Route path="/veterinarias/nueva" element={<NuevaVeterinaria />} />
          <Route path="/veterinarias/:id" element={<VeterinariaDetalle />} />
          <Route path="/veterinarias/:id/editar" element={<EditarVeterinaria />} />
          <Route path="/pagos" element={<Pagos />} />
          <Route path="/reportes" element={<Reportes />} />
          <Route path="/configuracion" element={<Configuracion />} />
        </Route>
      </Route>

      {/* Ruta por defecto */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
